import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { SectionProps } from './types.js';

/** `<Section>` component. */
export const Section = ({
  children,
  className,
  icon,
  title,
  ...props
}: SectionProps): ReactElement => (
  <div className={twMerge('flex gap-16', className)} {...props}>
    <Icon className='text-3xl text-primary' icon={icon} />
    <div className='text-left'>
      <div className='mb-6 mt-4 font-bold'>{title}</div>
      {children}
    </div>
  </div>
);
